import { render } from "./PopularSeries.vue?vue&type=template&id=4288e0dc"
import script from "./PopularSeries.vue?vue&type=script&lang=js"
export * from "./PopularSeries.vue?vue&type=script&lang=js"

import "./PopularSeries.vue?vue&type=style&index=0&id=4288e0dc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__